const breakpoints = {
    xs: 414,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1224
};

export default breakpoints;